import React from 'react';
import { Tooltip } from '@material-ui/core';
import './main.css';
import chartRow from '../images/ZlvsWalkme Rows.svg';
import check from '../images/ZLvsWalkme-check.svg';
import cross from '../images/ZlvsWalkme-X.svg';

// Landing Pages Section 1D
function ZLChartRow(props) {
    return (
        <Tooltip title={props.title} placement="left" interactive arrow>
            <div className="ziplyne-chart__content__row">
                <img alt="" src={chartRow} />
                <p className="ziplyne-chart__content__row__title">
                    {props.title}
                </p>
                <div className="ziplyne-chart__content__row__ziplyne-info">
                    <img alt="" src={check} />
                </div>
                <div className="ziplyne-chart__content__row__walkme-info">
                    <img alt="" src={props.checkWalkme ? check : cross} />
                </div>
            </div>
        </Tooltip>
    );
}

export default ZLChartRow;